<template lang="pug">
.login-page.flex.column.align-center
  .header.flex.align-center
    .logo
  .content.flex.column.align-center.justify-center
    img.form-bg(:src="bgImg")
    .form.flex.column.align-stretch.gap-20
      .desc.flex.column
        div 歡迎來到蛹之生心理諮商所
        div Welcome to Metamorphosis Counseling Center
      .desc.flex.column
        div 用心理諮商陪你走生活的苦、解生命的結
        div
          span We use psychological counseling to accompany you&nbsp;
          span through the hardships of life and untie the knots of life.
      el-button
        .btn-content.flex.align-center.justify-center.gap-10(@click="goLINELogin")
          img(src="/line.png", width="18" height="18")
          .btn-text 使用 LINE 登入 Login via LINE
      .splitter.flex.align-center.gap-10
        .line.flex-1
        .text 或是 / or
        .line.flex-1
      .inputs.flex.column.gap-10
        .input.flex.column
          .title Email
          el-input(v-model.trim="email")
        .input.flex.column
          .title 密碼 Password
          el-input(v-model="password", type="password", show-password)
        el-button(type="primary", @click="doLogin") 登入 Login
        .forget-pass
          el-link(type="primary", @click="doForget") 忘記密碼? Forgot password?
      .contact-info.flex.column
        .row.flex.align-center.gap-4
          span 客服LINE帳號：
          el-link(type="primary", @click="goLinePage") @morphtw
        .row 客服信箱：reservation@morph.tw
        .row 客服電話：0968-070-620
        .row 服務時間：週一至週六 09:00-21:00，國定假日除外
</template>

<script>
import { mapMutations } from 'vuex';
import constant from '@/util/constant';
import { login, getProfile } from '@/api/auth';
import bgImg from '../images/login-bg-img.svg';

export default {
  data() {
    return {
      bgImg,
      email: '',
      password: '',
    };
  },
  methods: {
    ...mapMutations(['setUserInfo', 'setIsLINELogin']),
    doLogin() {
      if (this.email === '') {
        this.$showWarn('請輸入 Email');
        return;
      }
      if (this.password === '') {
        this.$showWarn('請輸入密碼');
        return;
      }
      let loggedIn = false;
      this.$execWithLoading(async () => {
        await login(this.email, this.password);
        loggedIn = true;
        this.email = '';
        this.password = '';
        const profile = await getProfile();
        this.setUserInfo(profile);
        this.$router.push({ name: 'Reserves' });
      }, (e) => {
        if (loggedIn) {
          // 帳密已驗證成功，是後續讀取個人資料失敗，不能顯示成「登入失敗」
          this.$showAxiosException('讀取個人資料失敗', e);
          return;
        }
        // 帳號不存在與密碼錯誤刻意回傳同一個 401、顯示同一句文案，避免被用來探測帳號是否存在
        if (e?.response?.status === 401) {
          this.$showError('帳號或密碼錯誤');
          return;
        }
        this.$showAxiosException('登入失敗', e);
      });
    },
    doForget() {
      this.$router.push('/forget-password');
    },
    goLINELogin() {
      const clinetID = constant.lineClientID;
      const redirectURL = encodeURIComponent(`${constant.appHost}`);
      const nonce = Math.floor(Math.random() * 1000);
      const state = 'login';
      const url = `https://access.line.me/oauth2/v2.1/authorize?response_type=code&client_id=${clinetID}&redirect_uri=${redirectURL}&scope=profile%20openid&nonce=${nonce}&state=${state}`;
      document.location.href = url;
    },
    goLinePage() {
      const url = 'https://lin.ee/u84WVJ2';
      window.open(url, '_blank');
    },
  },
  mounted() {
    this.setUserInfo(undefined);
  },
};
</script>

<style lang="scss" scoped>
.login-page {
  position: relative;
  .header {
    position: absolute;
    margin-top: 50px;
    width: 100vw;
    .logo {
      margin-left: 40px;
      box-sizing: border-box;
      flex: 0 0 285px;
      background-image: url('/black-logo-long.png');
      background-position: 50% 50%;
      background-size: 285px 45px;
      background-repeat: no-repeat;
      border-right: 1px solid white;
      border-top: 20px solid transparent;
      border-bottom: 20px solid transparent;
    }
  }
  .content {
    padding-top: 45px;
    flex: 1;
    max-width: 820px;
    width: 100vw;
    position: relative;
    .form-bg {
      position: absolute;
      top: calc(50% + 350px);
      right: 160px;
      transform: translate(100%, -100%);
      width: 22%;
      min-width: 160px;
    }
    .form {
      width: calc(100% - 70px);
      max-width: 386px;
      margin: 35px;

      .btn-text {
        margin-top: 3px;
        font-size: 13px;
      }
      .splitter {
        color: #909399;
        .line {
          border-bottom: 1px dashed #909399;
        }
      }
    }
  }
  .contact-info {
    font-size: 12px;
  }
}

@media screen and (max-width: 800px) {
  .login-page {
    .header {
      margin-top: 30px;
      .logo {
        margin-left: 35px;
        flex: 0 0 200px;
        background-size: 200px 32px;
      }
    }
  }
}
</style>
